// Tiny module-scoped handoff used to pass audience picker results back to the
// Announcement compose page without pushing/replacing a new history entry.
// This keeps the back stack clean: the picker calls history.goBack() instead of
// creating a duplicate /Announcement entry that the user has to back through.

export type AudienceAssociateLite = {
  WerkerUid: string;
  WerkerFirstName: string;
  WerkerLastName: string;
  WerkerProfilePicURL: string;
  WerkerCompany: string;
  WerkerBio: string;
  isSelected?: boolean;
};

export type PendingAudienceSelection = {
  selectedAssociates: AudienceAssociateLite[];
  selectedCrewIds: string[];
};

let pending: PendingAudienceSelection | null = null;

export const setPendingAudienceSelection = (payload: PendingAudienceSelection) => {
  pending = payload;
};

export const consumePendingAudienceSelection = (): PendingAudienceSelection | null => {
  const p = pending;
  pending = null;
  return p;
};
